import { ApolloProvider } from '@apollo/client';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { enUS } from 'date-fns/locale/en-US';
import { SnackbarProvider as NotistackProvider } from 'notistack';
import { ReactNode } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { I18nextProvider } from 'react-i18next';
import { BrowserRouter } from 'react-router-dom';

import { SnackbarProvider } from './components/Snackbar/SnackbarProvider';
import {
	StyledSnackbarContent,
	snackbarIconVariant
} from './components/Snackbar/StyledSnackbarContent';
import { client } from './core/graphql/ApolloClient/apolloClient';
import { i18n } from './core/i18n/i18n';
import { MatomoProvider } from './core/matomo/MatomoProvider';
import { theme } from './core/theme/theme';
import { Auth } from './features/Auth/Auth';
import { DcrFormRoot } from './features/DcrForm/DcrFormRoot';
import { getRouterBasename } from './utils/getRouterBasename';

export const AppProviders = ({ children }: { children: ReactNode }) => {
	return (
		<ApolloProvider client={client}>
			<MatomoProvider>
				<BrowserRouter basename={getRouterBasename()}>
					<I18nextProvider i18n={i18n}>
						<ThemeProvider theme={theme}>
							<LocalizationProvider
								dateAdapter={AdapterDateFns}
								adapterLocale={enUS}
							>
								<Auth>
									<CssBaseline enableColorScheme />
									<HelmetProvider>
										<NotistackProvider
											anchorOrigin={{
												vertical: 'bottom',
												horizontal: 'right'
											}}
											iconVariant={snackbarIconVariant}
											Components={{
												default: StyledSnackbarContent,
												success: StyledSnackbarContent,
												error: StyledSnackbarContent,
												warning: StyledSnackbarContent,
												info: StyledSnackbarContent
											}}
										>
											<SnackbarProvider>
												{children}
												<DcrFormRoot />
											</SnackbarProvider>
										</NotistackProvider>
									</HelmetProvider>
								</Auth>
							</LocalizationProvider>
						</ThemeProvider>
					</I18nextProvider>
				</BrowserRouter>
			</MatomoProvider>
		</ApolloProvider>
	);
};
